// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout'
import { roterPre } from '@/settings'
const teamRouter  =
  {
    path: `${roterPre}/team`,
    name: 'team',
    meta: {
      icon: '',
      title: '团队管理'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'menu',
        name: 'teamMenu',
        meta: {
          title: '团队菜单管理'
        },
        component: () => import('@/views/team/system/index')
      },
      {
        path: 'list',
        name: 'teamList',
        meta: {
          title: '团队列表'
        },
        component: () => import('@/views/team/list/index')
      }
    ]
  }
export default teamRouter
